exports.list = {
    path: '/permintaan_teknisi',
    name: 'permintaan_teknisi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/permintaan_teknisi/List.vue"),
}
exports.show = {
    path: '/permintaan_teknisi/show/:id',
    name: 'permintaan_teknisi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/permintaan_teknisi/Show.vue"),
}